import React from 'react';

import { useTranslation } from 'react-i18next';

import { useTimeRemaining } from '@hooks/use-time-remaining';

import * as Styled from './timer-block.styled';

type OwnProps = {
	isCompleted: boolean;
	isPending: boolean;
	timerDate: string;
};

const MobileTimer = ({ isCompleted, timerDate }: Omit<OwnProps, 'isPending'>) => {
	const { t } = useTranslation();
	const timeLeft = useTimeRemaining(timerDate);

	if (isCompleted || timeLeft.isFinished) {
		return null;
	}

	return (
		<Styled.MobileTimer>
			{timeLeft.days > 0 && `${timeLeft.days}${t('days.short')} `}
			{timeLeft.hours}
			{t('hours.short')} {timeLeft.minutes}
			{t('minutes.short')}
		</Styled.MobileTimer>
	);
};

export const TimerBlock = ({ isCompleted, isPending, timerDate }: OwnProps) => {
	const { t } = useTranslation();
	const timeLeft = useTimeRemaining(timerDate);

	if (isCompleted) {
		return null;
	}

	if (timeLeft.isFinished) {
		return (
			<Styled.RaceTimer>
				<Styled.TimerValues>{t('finished_m')}</Styled.TimerValues>;
			</Styled.RaceTimer>
		);
	}

	return (
		<Styled.RaceTimer>
			<Styled.TimerLabel>{isPending ? t('before_start') : t('before_finish')}</Styled.TimerLabel>
			<Styled.TimerValues>
				{timeLeft.days > 0 && (
					<Styled.TimerUnit>
						<Styled.TimerValue>{timeLeft.days}</Styled.TimerValue>
						<Styled.TimerUnitLabel>{t('days.short')}</Styled.TimerUnitLabel>
					</Styled.TimerUnit>
				)}
				<Styled.TimerUnit>
					<Styled.TimerValue>{timeLeft.hours}</Styled.TimerValue>
					<Styled.TimerUnitLabel>{t('hours.short')}</Styled.TimerUnitLabel>
				</Styled.TimerUnit>
				<Styled.TimerSeparator>:</Styled.TimerSeparator>
				<Styled.TimerUnit>
					<Styled.TimerValue>{timeLeft.minutes}</Styled.TimerValue>
					<Styled.TimerUnitLabel>{t('minutes.short')}</Styled.TimerUnitLabel>
				</Styled.TimerUnit>
			</Styled.TimerValues>
		</Styled.RaceTimer>
	);
};

TimerBlock.Mobile = MobileTimer;
